import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Button, EmptyState, SectionHeader, Spinner } from "../../../components/ui";

interface SectionFrameProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  filters?: ReactNode;
  loading?: boolean;
  error?: unknown;
  onRetry?: () => void;
  children: ReactNode;
}

/** Marco común de las secciones: encabezado, carga, error y cuerpo con scroll. */
export function SectionFrame({ title, subtitle, actions, filters, loading, error, onRetry, children }: SectionFrameProps) {
  const { t } = useTranslation("radarCorreo");
  return (
    <div className="flex h-full w-full flex-col">
      <SectionHeader title={title} subtitle={subtitle} actions={actions} filters={filters} />
      <div className="flex-1 overflow-y-auto p-3 sm:p-6">
        <div className="mx-auto w-full max-w-6xl space-y-5">
          {loading ? (
            <div className="flex items-center justify-center gap-2 py-16 text-sm text-content-secondary">
              <Spinner size="md" /> {t("common.loading")}
            </div>
          ) : error ? (
            <EmptyState
              icon="ri-error-warning-line"
              title={t("common.error")}
              action={onRetry ? <Button variant="secondary" size="sm" onClick={onRetry}>{t("common.retry")}</Button> : undefined}
            />
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
}
